<template>
    <div id="FiltersPage" class="Page Filters">
      <div class="Section Filters_header">

        <div class="Section_wrapper">
          <div class="Shapes">
            <transition name="fade" appear>
              <img class="Shape" src="../../public/static/images/shape-red.svg" />
            </transition>
            <transition name="fade" appear>
              <img class="Shape" src="../../public/static/images/shape-red.svg" />
            </transition>
          </div>

          <transition name="bottom" appear>
            <h2>Les résultats du Baromètre 2019</h2>
          </transition>
          <transition name="bottom" appear>
            <p><strong>Explorez les réponses des 4850 répondants, thématique par thématique et comparez-vous !</strong></p>
          </transition>

          <PageNav :data="nav" />
        </div>


        <img class="Filters_header_illustration" src="../../public/static/images/illustrations/i_househeader.svg" />
      </div>

      <div class="Page_wrapper">
        <transition name="fade" appear mode="out-in">
          <div class="Page_content" v-if="data && filters" :key="$route.params.slug">
            <div class="Page_content_intro">
              <div class="Slash" v-if="$route.params.slug == 'qualiscore'"></div>
              <Media :data="$tools.path() + '/static/images/illustrations/qualiscore-filters.svg'" v-if="$route.params.slug == 'qualiscore'" />
              <Media :data="$tools.path() + '/static/images/illustrations/attractivite-filters.svg'" v-if="$route.params.slug == 'attractivite'" />
              <Media :data="$tools.path() + '/static/images/illustrations/relations-filters.svg'" v-if="$route.params.slug == 'relations'" />
              <Media :data="$tools.path() + '/static/images/illustrations/attachement-filters.svg'" v-if="$route.params.slug == 'attachement'" />
              <h3 v-if="$route.params.slug == 'qualiscore'">Le Qualiscore 2019</h3>
              <h3 v-if="$route.params.slug == 'attractivite'">L'attractivité des territoires</h3>
              <h3 v-if="$route.params.slug == 'relations'">Les relations sociales dans sa sommune</h3>
              <h3 v-if="$route.params.slug == 'attachement'">L'attachement à son logement</h3>
              <p class="Filters_intro" v-if="$route.params.slug == 'qualiscore'">Isolation acoustique, qualité de l’air, performance environnementale, sécurité… Découvrez ce qui influe sur la qualité perçue du logement des Français.</p>
              <p class="Filters_intro" v-if="$route.params.slug == 'relations'">Les Français ont-ils de bonnes relations avec leur voisinage ? Découvrez les réponses du Baromètre Qualitel 2019 et filtrez les résultats pour obtenir des données en fonction des profils des répondants.</p>
              <p class="Filters_intro" v-if="$route.params.slug == 'attractivite'">Où fait-il bon loger en France ? Découvrez les réponses des Français, filtrez les résultats et découvrez les différences entre les profils des répondants.</p>
              <p class="Filters_intro" v-if="$route.params.slug == 'attachement'">Les Français sont-ils attachés à leur logement ? Quels sont les critères qui font la fierté de leur logement ? A l'inverse, pourquoi certains Français choisissent de déménager ? Découvrez toutes les réponses du Baromètre Qualitel 2019.</p>
            </div>
            <section class="Section" id="Content">
              <div class="Section_wrapper">
                <QualiscoreFilters key="qualiscore" :filters="filters" index="qualiscore" v-if="score" :data="score" @openPanel="onOpenPanel"/>
                <h3 v-if="$route.params.slug == 'qualiscore'">Les résultats en détails</h3>
                <div class="Cols" ref="cols">
                  <transition name="fade" mode="out-in">
                    <div class="Col" ref="questions" :key="data.noResults ? 'noResults' : 'results'">
                      <QuestionFilters v-for="(question, index) in questions" :key="index + '-' + keys" :filters="filters" :data="question" :noResults="data.noResults" :index="index" :userAnswer="userResponse(question.id)" :advice="questionAdvice(question.ref)" />
                    </div>
                  </transition>
                  <div class="Col" id="Sidebar" v-show="!isMobile">
                    <FiltersBlock :filters="filters" ref="filters" @filters="filtersQuestions" :key="$route.params.slug + '-desktop'" />
                  </div>
                </div>
                <h3 class="SurveysTitle">Consultez les résultats des autres thématiques</h3>
                <SurveysSwiper :data="surveysPush" />
              </div>
            </section>

            <transition name="normal">
              <FiltersBlockMobile :filters="filters" ref="filtersMobile" @filters="filtersQuestions" :key="$route.params.slug + '-mobile'" v-show="isMobile && filtersVisible" />
            </transition>
          </div>
        </transition>
      </div>

      <Footer />
    </div>
</template>

<script>
  import page from '@/mixins/page'
  import Vue from 'vue'
  import router from '@/router'
  import store from '@/store'
  import { mapActions, mapState } from 'vuex'

  import Footer from '@/components/partials/Footer'
  import QuestionFilters from '@/components/QuestionFilters'
  import QualiscoreFilters from '@/components/QualiscoreFilters'
  import SurveysSwiper from '@/components/SurveysSwiper'
  import Media from '@/components/Media'
  import PageNav from '@/components/PageNav'
  import FiltersBlock from '@/components/FiltersBlock'
  import FiltersBlockMobile from '@/components/FiltersBlockMobile'

  export default {
    name: "Filters",
    mixins: [ 'page' ],
    components: { Footer, QuestionFilters, QualiscoreFilters, PageNav, Media, SurveysSwiper, FiltersBlock, FiltersBlockMobile },
    metaInfo: {
      title: 'Baromètre Qualitel 2019 : explorer les réponses des Français sur la qualité de leur logement.',
      meta: [
        {
          property: 'og:title',
          content: 'Baromètre Qualitel 2019 : explorer les réponses des Français sur la qualité de leur logement.'
        },
        {
          property: 'og:description',
          content: 'Où fait-il bon se loger en France ? Consultez les réponses des Français, filtrez les données et comparez-vous avec les résultats du baromètre Qualitel 2019.'
        },
        {
          property: 'og:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-3.jpg'
        },
        {
          property: 'twitter:title',
          content: 'Baromètre Qualitel 2019 : explorer les réponses des Français sur la qualité de leur logement.'
        },
        {
          property: 'twitter:description',
          content: 'Où fait-il bon se loger en France ? Consultez les réponses des Français, filtrez les données et comparez-vous avec les résultats du baromètre Qualitel 2019.'
        },
        {
          property: 'twitter:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-3.jpg'
        }
      ]
    },
    data() {
      return {
        filtersVisible: false,
        isMobile: false,
        position: null,
        data: null,
        keys: null,
        filters: null,
        score: null,
        questions: [],
        userQualiscore: null,
        surveysPush: [],
        nav: [
          {
            to: this.$tools.path() + '/enquete/qualiscore',
            label: 'Le Qualiscore 2019'
          },
          {
            to: this.$tools.path() + '/enquete/attractivite',
            label: "L'attractivité des territoires"
          },
          {
            to: this.$tools.path() + '/enquete/relations',
            label: 'Les relations sociales dans sa commune'
          },
          {
            to: this.$tools.path() + '/enquete/attachement',
            label: 'L’attachement à son logement'
          }
        ]
      }
    },
    beforeRouteEnter (to, from, next) {
      Vue.$api.getSurveyFilters(to.params.slug, to.params.filters_slug)
      .then(response => {
        var survey = response.data.data

        Vue.$api.getFilters(to.params.slug)
        .then(response => {
          var filters = response.data.data

          if(to.params.slug === 'qualiscore')
          {
            Vue.$api.getSurveyFiltersQualiscore(to.params.slug, 'all,all')
            .then(response => {
              var score = response.data.data

              Vue.$api.getSurveyFiltersParticipant(store.state.user.token, to.params.slug)
              .then(response => {
                next(vm => vm.setData(survey, filters, score, response.data.data))
              })
            })
          }else{
            next(vm => vm.setData(survey, filters))
          }
        })
      })
      .catch( () => {
        router.push({ name: "404" })
      })
    },
    beforeRouteUpdate (to, from, next) {
      // this.data = null
      // this.filters = null

      this.$api.getSurveyFilters(to.params.slug, to.params.filters_slug)
      .then(response => {
        var survey = response.data.data

        this.$api.getFilters(to.params.slug)
        .then(response => {
          var filters = response.data.data

          if(to.params.slug === 'qualiscore')
          {
            this.$api.getSurveyFiltersQualiscore(to.params.slug, 'all,all')
            .then(response => {
              var score = response.data.data

              this.$api.getSurveyFiltersParticipant(this.user.token, to.params.slug)
              .then(response => {
                next(this.setData(survey, filters, score, response.data.data))
                this.updateSurveysPush()
              })
            })
          }else{
            next(this.setData(survey, filters))
            this.updateSurveysPush()
          }
        })

      })
      .catch( () => {
        this.$router.push({ name: "404" })
      })
    },
    computed: {
      ...mapState([
        'user'
      ])
    },
    watch: {
      data()
      {
        console.log('data change')
        let questions = []
        this.data.questions.forEach( question => {
          if(question.type != 'annexe')
          {
            questions.push(question)
          }
        })

        this.questions = questions
        this.keys = Math.random()
      }
    },
    methods: {
      ...mapActions([

      ]),
      filtersQuestions(questions)
      {
        console.log('filtersQuestionMaj', questions)
        this.data = questions
      },
      onOpenPanel(panel)
      {
        this.$emit('openPanel', panel)
      },
      questionAdvice(ref)
      {
        if(this.data.noteslist)
        {
          return this.data.noteslist.find(x => x.question_ref === String(ref))
        }
      },
      userResponse(id)
      {
        if(this.userQualiscore)
        {
          return this.userQualiscore.questions.find(x => x.id === id)
        }
      },
      setData(survey, filters, score, userQualiscore)
      {
        if(!survey || survey.length <= 0)
        {
          this.$router.push({ name: "404" })
        }

        window.scrollTo(0,0)

        this.data = survey
        this.filters = filters
        this.score = score
        this.userQualiscore = userQualiscore

        this.onWheel()
      },
      updateSurveysPush()
      {
        this.surveysPush = []

        let qualiscore = {
          slug: 'qualiscore',
          title: 'Le Qualiscore 2019',
          illustration: this.$tools.path() + '/static/images/illustrations/qualiscore-filters.svg'
        }

        let attractivite = {
          slug: 'attractivite',
          title: 'L’attractivité des territoires',
          illustration: this.$tools.path() + '/static/images/illustrations/attractivite-filters.svg'
        }

        let relations = {
          slug: 'relations',
          title: 'Les relations sociales dans sa commune',
          illustration: this.$tools.path() + '/static/images/illustrations/relations-filters.svg'
        }

        let attachement = {
          slug: 'attachement',
          title: 'L’attachement à son logement',
          illustration: this.$tools.path() + '/static/images/illustrations/attachement-filters.svg'
        }

        console.log('slug', this.$route.params.slug)

        if(this.$route.params.slug == "qualiscore")
        {
          this.surveysPush.push(attractivite)
          this.surveysPush.push(relations)
          this.surveysPush.push(attachement)
        }
        if(this.$route.params.slug == "attractivite")
        {
          this.surveysPush.push(qualiscore)
          this.surveysPush.push(relations)
          this.surveysPush.push(attachement)
        }
        if(this.$route.params.slug == "relations")
        {
          this.surveysPush.push(qualiscore)
          this.surveysPush.push(attractivite)
          this.surveysPush.push(attachement)
        }
        if(this.$route.params.slug == "attachement")
        {
          this.surveysPush.push(qualiscore)
          this.surveysPush.push(attractivite)
          this.surveysPush.push(relations)
        }
      },
      onResize()
      {
        if(window.innerWidth > 1260)
        {
          this.isMobile = false
        }else{
          this.isMobile = true
        }
      },
      onWheel(e)
      {
        if(!this.$refs.questions) return

        let rect = this.$refs.questions.getBoundingClientRect()
        if(rect.top <= 200 && rect.top >= -(rect.height - 500))
        {
          this.filtersVisible = true
        }else{
          this.filtersVisible = false
        }
      }
    },
    updated()
    {
      // console.log('update')
      // this.updateSurveysPush()
    },
    beforeDestroy()
    {
      window.removeEventListener('resize', this.onResize)
      window.removeEventListener('scroll', this.onWheel)
    },
    mounted()
    {
      this.$el.querySelectorAll('.Shape').forEach( el => {
        this.$scroll.set(el, { y: -70 }, { y: 0 }, { y: -140 }, null, -2)
      })

      this.updateSurveysPush()

      window.addEventListener('resize', this.onResize)
      this.onResize()

      window.addEventListener('scroll', this.onWheel)
      this.onWheel()
    }
  }
</script>

<style lang="stylus">
.Filters

  

  .Cols

    display flex
    flex-direction row
    justify-content space-between
    align-items flex-start
    width 100%
    max-width 1200px
    margin auto

    @media screen and (max-width: 1260px)

      display flex
      flex-direction column-reverse

    .Col

      width 100%
      position relative
      max-width 590px

      @media screen and (max-width: 1260px)

        max-width unset

      &:last-child

        display flex
        flex-direction row
        align-items center
        width 100%
        max-width 390px
        margin-left auto
        margin-right auto

        @media screen and (max-width: 1260px)
          
          max-width unset

        div:first-child

          width 100%

  #Content

    padding-top 15px

    h3

      margin-top 45px

    h3.SurveysTitle

      margin-top 100px

  .Shapes

    position absolute
    top 0px
    left 0px
    width 100%
    height 100%
    overflow hidden

  .Page_content_intro

    background-color white
    padding 60px 0px 60px 0px
    position relative
    text-align center

    .Media

      margin-bottom 20px
      position relative
      z-index 1

    h3

      margin-left auto
      margin-right auto
      position relative
      z-index 1

    p

      margin auto auto
      position relative
      z-index 1
      width calc(100% - 25px - 25px)
      max-width 590px

  .Page_wrapper

    background-color #F8F8F8

  &_intro

    max-width 590px

    @media $medium

      margin-bottom 50px

  .Filters_header

    background-color $blue
    z-index 2
    color white
    display table
    overflow visible

    @media $small

      overflow-x unset

    &_illustration

      position absolute
      bottom -30px
      right 15px
      width 100px

      @media $large

        display none

    .Section_wrapper

      padding-bottom 0px
      height 100%
      // overflow-y hidden
      width 100%

      @media $medium

        overflow-y visible

    .Shape:nth-child(1)

      width 356px
      height 356px
      left -200px
      top -20px

      @media $medium

        width 208px
        height 208px
        left -110px
        top -60px

    .Shape:nth-child(2)

      width 140px
      height 140px
      right 50px
      top -50px

      @media $medium

        width 122px
        height 122px
        right -25px
        top -80px

    h2, p

      position relative

    p

      color white
      transition-delay 0.1s

      strong

        font-weight 400
</style>
